import { ChangePolicyEmailComponent } from '../change-policy-email/change-policy-email.component';
import { MapfreCardComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ModalOptions } from '@mapfre-design-library/src/public_api';
import { UserDataService } from '../../../../../../_services/data-services/user-data.service';
import { ActivatedRoute , RouterModule } from '@angular/router';
import { EmailService } from '../../../../../../_services/email/email.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreCardComponent, ChangePolicyEmailComponent],
  selector: 'app-email-not-associated-with-policy',
  templateUrl: './email-not-associated-with-policy.component.html',
  styleUrls: ['./email-not-associated-with-policy.component.scss'],
})
export class EmailNotAssociatedWithPolicyComponent implements OnInit {
  whereToFindModalOptions: ModalOptions;
  uploadingFiles: ModalOptions;
  policyId: string;
  emailMask: string;
  userDetails;
  constructor(
    private userDataService: UserDataService,
    private activatedRoute: ActivatedRoute,
    private emailService: EmailService
  ) {
    this.uploadingFiles = new ModalOptions({
      additionalClasses: 'modal-lg modal-dialog center-on-page confirm-modal',
      animatePosition: 'top',
      onLoad: true,
      modalId: 'policyEmailDoesnotMatchEmail',
      iconClasses: 'far fa-user-circle',
      iconFamily: 'font-awesome',
      modalTranslateCopy: '',
      modalName: 'policy_email_doesnot_match_email',
    });
  }
  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.policyId = params['id'];
    });
    this.getUserData();
  }
  getUserData() {
    this.userDataService.$userData.subscribe((user) => {
      if (user && user.userDetails) {
        this.userDetails = user.userDetails;
        this.emailMask = this.emailService.maskEmail(
          this.userDetails.email.address
        );
      }
    });
  }
}
